export const CheckIcon = () => {
  return <span>✅</span>
}
